import { firstParam } from '@utilities/http/firstParam';

const PAGE_ROUTE_KEYS = new Set([
  'productListName',
  'productId',
  'productSlug',
  'slug',
  'irc',
]);

const INDEXABLE_QUERY_KEYS = new Set(['pageNumber', 'pageSize']);

export const OTC_PLP_API_KEYS = [
  'categoryCodeLevel1',
  'pageNumber',
  'pageSize',
  'shapeCode',
] as const;

export const PDP_API_KEYS = ['irc', 'brandName', 'categoryCodeLevel3'] as const;

export const SUPPLEMENT_PLP_API_KEYS = [
  'categoryCodeLevel1',
  'categoryCodeLevel2',
  'categoryCodeLevel3',
  'categoryCodeLevel4',
  'pageNumber',
  'pageSize',
  'shapeCode',
  'brand',
  'sort',
  'BestSeller',
  'MostVisited',
  'MostDiscounted',
  'MostExpensive',
  'Cheapest',
] as const;

export const SUPPLEMENT_FILTER_API_KEYS = [
  'categoryCodeLevel1',
  'categoryCodeLevel2',
  'categoryCodeLevel3',
  'categoryCodeLevel4',
] as const;

const SORT_FLAGS = new Set([
  'BestSeller',
  'MostVisited',
  'MostDiscounted',
  'MostExpensive',
  'Cheapest',
]);

export const applyPlpSortQuery = (query: Record<string, string>) => {
  const sort = query.sort;
  if (!sort || !SORT_FLAGS.has(sort)) return query;
  const { sort: _sort, ...rest } = query;
  return { ...rest, [sort]: '1' };
};

export const pickApiQuery = (
  query: Record<string, unknown> = {},
  extra: Record<string, unknown> = {},
  options?: { allowKeys?: readonly string[] },
) => {
  const next: Record<string, string> = {};
  const allow = options?.allowKeys ? new Set(options.allowKeys) : null;

  const assign = (key: string, value: unknown, fromExtra = false) => {
    if (!fromExtra && PAGE_ROUTE_KEYS.has(key)) return;
    if (value == null || value === '') return;
    if (allow && !allow.has(key)) return;
    const normalized = Array.isArray(value) ? value[0] : value;
    if (normalized == null || normalized === '') return;
    next[key] = String(normalized);
  };

  Object.entries(extra).forEach(([key, value]) => assign(key, value, true));
  Object.entries(query).forEach(([key, value]) => assign(key, value));

  return next;
};

export const shouldNoIndexCatalogQuery = (
  query: Record<string, unknown> = {},
) =>
  Object.entries(query).some(([key, value]) => {
    if (PAGE_ROUTE_KEYS.has(key) || INDEXABLE_QUERY_KEYS.has(key)) return false;
    if (value == null || value === '') return false;
    return true;
  });

export const getPageNumberFromQuery = (
  query: Record<string, unknown>,
  fallback = 1,
) => {
  const value = Number(firstParam(query.pageNumber as string | string[]));
  return Number.isFinite(value) && value > 0 ? value : fallback;
};
